<app-no-contract></app-no-contract>
<nb-tabset class="bg-white" *ngIf="isContractActive" fullWidth>
    <!-- badge tab-->
    <nb-tab tabTitle="{{'pages_titles.badges' | translate}}" class="tab" tabIcon="credit-card-outline"
        nbSpinnerSize="large">
        <app-loader *ngIf="loadingSpinner"></app-loader>
        <div class="text-center mt-5 mb-5" *ngIf="offers?.badges.length === 0">
            <p class="p-text">{{'no-access-history-text' | translate}} !</p>
            <button class="mt-4 btn btn-outline-primary" (click)="redirectAvailableServices('badge')">
                {{'get-pack' | translate }}
            </button>
        </div>
        <div class="mt-4" *ngIf="offers?.badges.length !== 0 && !loadingSpinner">
            <div class="space cardBodyLayout mt-2">
                <div class="w-100 center ">

                    <table class="table-form" #DataTableBadge="mfDataTable" [mfData]="AllBadge" #mf="mfDataTable" [mfRowsOnPage]="10">

                        <thead class="thead-form">
                            <tr>
                                <th scope="col"> {{'Actions' | translate}}</th>
                                <th scope="col"><mfDefaultSorter by="createdAt">{{'createdAt' | translate}}</mfDefaultSorter></th>

                                <th scope="col"><mfDefaultSorter by="Price">{{'Price' | translate}}</mfDefaultSorter></th>
                            </tr>
                        </thead>
                        <tbody>
                            <tr class="not-display"></tr>

                            <tr *ngFor="let data of mf.data ; index as i">
                                <td attr.data-label="{{'Actions' | translate}}">
                                    <div>
                                        <i class="pi pi-eye text-primary"
                                            (click)="openDialog('details' ,data.activationHistory)"
                                            pTooltip="{{'tooltip.service_show' | translate}}"
                                            tooltipPosition="bottom"></i>
                                    </div>
                                </td>
                                <td attr.data-label="{{'createdAt' | translate}}">
                                    <p class="text-center overflow-auto">{{data.createdAt}}</p>
                                </td>
                                <td attr.data-label="{{'Price' | translate}}">
                                    <p class="text-center overflow-auto"><strong>{{data.Price}}</strong></p>
                                </td>

                            </tr>

                        </tbody>
                        <tfoot>
                            <tr>
                                <td colspan="2">
                                    <mfBootstrapPaginator #Paginator [rowsOnPageSet]="[10,25,50,75]">
                                    </mfBootstrapPaginator>
                                </td>
                            </tr>
                        </tfoot>
                    </table>

                    <div *ngIf="noDataSearchBadge" class="no-data-search">
                        <img src="assets/images/empty-data.png" class="responsive-image" alt="empty-data-image" />
                        <p class="no-data-found w-100">{{'NO_DATA_SEARCH' | translate}}</p>
                    </div>
                </div>
            </div>
        </div>
    </nb-tab>

    <!-- application mobile APK -->
    <nb-tab tabTitle="{{'custom_mobile_app' | translate}}" class="tab" tabIcon="smartphone-outline"
        nbSpinnerSize="large">
        <div class="text-center mt-5 mb-5" *ngIf="offers?.custom_mobile_app.length === 0">
            <p class="p-text">{{'no-access-history-text' | translate}} !</p>
            <button class="mt-4 btn btn-outline-primary" (click)="redirectAvailableServices('mobile')">
                {{'get-pack' | translate }}
            </button>
        </div>
        <div class="mt-4" *ngIf="offers?.custom_mobile_app.length !== 0">
            <div class="space cardBodyLayout mt-2">
                <div class="w-100 center" >

                    <table class="table-form" #DataTableApk="mfDataTable" [mfData]="AllApk" #mf="mfDataTable" [mfRowsOnPage]="10">

                        <thead class="thead-form">
                            <tr>

                                <th scope="col"> {{'Actions' | translate}}</th>
                                <th scope="col"><mfDefaultSorter by="createdAt">{{'createdAt' | translate}}</mfDefaultSorter></th>
                                <th scope="col"><mfDefaultSorter by="Price">{{'Price' | translate}}</mfDefaultSorter></th>
                            </tr>
                        </thead>
                        <tbody>
                            <tr class="not-display"></tr>
                            <tr *ngFor="let data of mf.data ; index as i">
                                <td attr.data-label="{{'Actions' | translate}}">
                                    <div>
                                        <i class="pi pi-eye text-primary"
                                            (click)="openDialog('details' ,data.activationHistory)"
                                            pTooltip="{{'tooltip.service_show' | translate}}"
                                            tooltipPosition="bottom"></i>
                                    </div>
                                </td>
                                <td attr.data-label="{{'createdAt' | translate}}">
                                    <p class="text-center overflow-auto">{{data.createdAt}}</p>
                                </td>
                                <td attr.data-label="{{'Price' | translate}}">
                                    <p class="text-center overflow-auto"><strong>{{data.Price}}</strong></p>
                                </td>

                            </tr>

                        </tbody>
                        <tfoot>
                            <tr>
                                <td colspan="2">
                                    <mfBootstrapPaginator #Paginator [rowsOnPageSet]="[10,25,50,75]">
                                    </mfBootstrapPaginator>
                                </td>
                            </tr>
                        </tfoot>
                    </table>


                    <div *ngIf="noDataSearchApk" class="no-data-search">
                        <img src="assets/images/empty-data.png" class="responsive-image" alt="empty-data-image" />
                        <p class="no-data-found w-100">{{'NO_DATA_SEARCH' | translate}}</p>
                    </div>
                </div>
            </div>
        </div>
    </nb-tab>

    <!-- offer xchange -->
    <nb-tab tabTitle="{{'pages_titles.generate_xchange' | translate}}" tabIcon="message-circle-outline" class="tab"
        [nbSpinner]="loadingSpinner" nbSpinnerStatus="danger" nbSpinnerSize="large">
        <div class="text-center mt-5 mb-5" *ngIf="offers?.xchange.length === 0">
            <p class="p-text">{{'no-access-history-text' | translate}} !</p>
            <button class="mt-4 btn btn-outline-primary" (click)="redirectAvailableServices('xchange')">
                {{'get-pack' | translate }}
            </button>
        </div>
        <div class="mt-4" *ngIf="offers?.xchange.length !== 0">
            <div class="space cardBodyLayout mt-2">
                <div class="w-100 center" >

                    <table class="table-form" #DataTableApk="mfDataTable" [mfData]="allXchange" #mf="mfDataTable" [mfRowsOnPage]="10">

                        <thead class="thead-form">
                            <tr>

                                <th scope="col"> {{'Actions' | translate}}</th>
                                <th scope="col"><mfDefaultSorter by="createdAt">{{'createdAt' | translate}}</mfDefaultSorter></th>
                                <th scope="col"><mfDefaultSorter by="Price">{{'Price' | translate}}</mfDefaultSorter></th>
                            </tr>
                        </thead>
                        <tbody>
                            <tr class="not-display"></tr>
                            <tr *ngFor="let data of mf.data ; index as i">
                                <td attr.data-label="{{'Actions' | translate}}">
                                    <div>
                                        <i class="pi pi-eye text-primary"
                                            (click)="openDialog('details' ,data.activationHistory)"
                                            pTooltip="{{'tooltip.service_show' | translate}}"
                                            tooltipPosition="bottom"></i>
                                    </div>
                                </td>
                                <td attr.data-label="{{'createdAt' | translate}}">
                                    <p class="text-center overflow-auto">{{data.createdAt}}</p>
                                </td>
                                <td attr.data-label="{{'Price' | translate}}">
                                    <p class="text-center overflow-auto"><strong>{{data.Price}}</strong></p>
                                </td>

                            </tr>

                        </tbody>
                        <tfoot>
                            <tr>
                                <td colspan="2">
                                    <mfBootstrapPaginator #Paginator [rowsOnPageSet]="[10,25,50,75]">
                                    </mfBootstrapPaginator>
                                </td>
                            </tr>
                        </tfoot>
                    </table>


                    <div *ngIf="noDataSearchApk" class="no-data-search">
                        <img src="assets/images/empty-data.png" class="responsive-image" alt="empty-data-image" />
                        <p class="no-data-found w-100">{{'NO_DATA_SEARCH' | translate}}</p>
                    </div>
                </div>
            </div>
        </div>
    </nb-tab>

    <!-- offer Support -->
    <nb-tab tabTitle="{{'support' | translate}}" class="tab" tabIcon="question-mark-circle-outline"
        nbSpinnerSize="large">
        <div class="text-center mt-5 mb-5" *ngIf="offers?.support.length === 0">
            <p class="p-text">{{'no-access-history-text' | translate}} !</p>
            <button class="mt-4 btn btn-outline-primary" (click)="redirectAvailableServices('support')">
                {{'get-pack' | translate }}
            </button>
        </div>

        <div class="mt-4" *ngIf="offers?.support.length !== 0">
            <div class="space cardBodyLayout mt-2">
                <div class="w-100 center" >

                    <table class="table-form" #DataTableApk="mfDataTable" [mfData]="AllSupport" #mf="mfDataTable" [mfRowsOnPage]="10">

                        <thead class="thead-form">
                            <tr>

                                <th scope="col"> {{'Actions' | translate}}</th>
                                <th scope="col"><mfDefaultSorter by="createdAt">{{'createdAt' | translate}}</mfDefaultSorter></th>
                                <th scope="col"><mfDefaultSorter by="Price">{{'Price' | translate}}</mfDefaultSorter></th>
                            </tr>
                        </thead>
                        <tbody>
                            <tr class="not-display"></tr>
                            <tr *ngFor="let data of mf.data ; index as i">
                                <td attr.data-label="{{'Actions' | translate}}">
                                    <div>
                                        <i class="pi pi-eye text-primary"
                                            (click)="openDialog('details' ,data.activationHistory)"
                                            pTooltip="{{'tooltip.service_show' | translate}}"
                                            tooltipPosition="bottom"></i>
                                    </div>
                                </td>
                                <td attr.data-label="{{'createdAt' | translate}}">
                                    <p class="text-center overflow-auto">{{data.createdAt}}</p>
                                </td>
                                <td attr.data-label="{{'Price' | translate}}">
                                    <p class="text-center overflow-auto"><strong>{{data.Price}}</strong></p>
                                </td>

                            </tr>

                        </tbody>
                        <tfoot>
                            <tr>
                                <td colspan="2">
                                    <mfBootstrapPaginator #Paginator [rowsOnPageSet]="[10,25,50,75]">
                                    </mfBootstrapPaginator>
                                </td>
                            </tr>
                        </tfoot>
                    </table>


                    <div *ngIf="noDataSearchApk" class="no-data-search">
                        <img src="assets/images/empty-data.png" class="responsive-image" alt="empty-data-image" />
                        <p class="no-data-found w-100">{{'NO_DATA_SEARCH' | translate}}</p>
                    </div>
                </div>
            </div>
        </div>
    </nb-tab>
</nb-tabset>

<!--  modal disable offer -->
<p-dialog header="{{'service_detail' | translate}}" [(visible)]="displayDetailsModal" [modal]="true"
    [style]="{width: '30vw'}" [draggable]="false" [resizable]="false">
    <div *ngIf="activationHistory?.length === 0" class="text-center">
        {{'noHistoryFound' | translate}}
    </div>
    <div *ngFor="let history of activationHistory">
        <div class="row">
            <div class="col-lg-4 col-md-12 col-sm-12 text-center">
                <label>{{'Type' | translate}} :</label>
            </div>
            <div class="col-lg-6 col-md-12 col-sm-12">
                <p>{{history.type | translate}}</p>
            </div>
        </div>
        <div class="row">
            <div class="col-lg-4 col-md-12 col-sm-12 text-center">
                <label>{{'Date' | translate}} :</label>
            </div>
            <div class="col-lg-6 col-md-12 col-sm-12">
                <p>{{history.date | date: 'MM-dd-yyyy HH:mm'}}</p>
            </div>
        </div>
        <hr />
    </div>
</p-dialog>